import { NgIf, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { BytesizeIconPipe } from '@portal/pipe';
import { coerceNumberProperty, NumberInput } from '@angular/cdk/coercion';

@Component({
  selector: 'portal-ui-header',
  standalone: true,
  imports: [NgIf, BytesizeIconPipe, NgStyle],
  templateUrl: './header.component.html',
  styles: [':host {@apply block;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @Input() homeUrl = '/';
  @HostBinding() class = 'fixed top-0 left-0 right-0 z-20 duration-200';
  @Output() burgerClick = new EventEmitter<void>();

  @HostBinding('class.bg-primary') get classBgPrimary() {
    return this.isScroll;
  }

  private _openSidenav = false;

  get openSidenav() {
    return this._openSidenav;
  }

  @Input() set openSidenav(value) {
    this._openSidenav = value;
  }

  private _isScroll = false;

  get isScroll() {
    return this._isScroll;
  }

  @Input() set isScroll(value) {
    this._isScroll = value;
  }

  private _height = 56;

  get height(): number {
    return this._height;
  }

  @Input() set height(value: NumberInput) {
    this._height = coerceNumberProperty(value, 56);
  }
}
